"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowLeft01Icon,
  ArrowRight01Icon,
} from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";
import { Button } from "../button";
import { useCarousel } from "../carousel";
import { promoCarouselArrowVariants } from "./variants";

type Props = {
  direction: "previous" | "next";
  label: string;
};

const PromoCarouselArrow: FC<Props> = ({ direction, label }) => {
  const { scrollPrev, scrollNext, canScrollPrev, canScrollNext } =
    useCarousel();
  const isPrevious = direction === "previous";

  if (isPrevious ? !canScrollPrev : !canScrollNext) {
    return null;
  }

  return (
    <Button
      data-slot={`promo-carousel-${direction}`}
      variant="outline"
      size="icon-xs"
      aria-label={label}
      onClick={isPrevious ? scrollPrev : scrollNext}
      className={promoCarouselArrowVariants({ direction })}
    >
      <HugeiconsIcon
        icon={isPrevious ? ArrowLeft01Icon : ArrowRight01Icon}
        className="rtl:rotate-180"
      />
    </Button>
  );
};

export default PromoCarouselArrow;
